export class TariffNameListVM{
    tariffId: number;
    tariffName: string;
}
